<template>
    <div 
        class="d-flex align-items-center justify-content-between  flex-column flex-lg-row mt-3" 
        v-if="typeof paginated !== 'undefined' && paginated">
        <div class="pagination-info mb-3">
            {{ translate('app.table.pagination.info', {first: records.from ?? 0, last: records.to ?? 0, total: records.total ?? 0}) }}
        </div>

        <div class="mb-3" v-if="records.last_page > 1">
            <nav>
                <ul class="pagination">
                    <template v-for="(link, index) in records.links" :key="index">
                        <li
                            :class="`page-item ${link.active ? 'active' : ''} ${link.url == null ? 'disabled' : ''}`"
                        >
                            <span class="page-link" v-if="link.active" v-text="link.label"></span>

                            <span class="page-link" v-else-if="index == 0 && link.url == null">&lsaquo;</span>

                            <span class="page-link" v-else-if="index == records.links.length - 1 && link.url == null">&rsaquo;</span>

                            <a
                                v-else
                                href="javascript:void(0);"
                                :data-page="link.url"
                                class="page-link"
                                @click="changePage(link.url)"
                            >
                                <template v-if="index == 0">&lsaquo;</template>
                                <template v-else-if="index == records.links.length - 1">&rsaquo;</template>
                                <template v-else>{{ link.label }}</template>
                            </a>
                        </li>
                    </template>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    props: ['paginated', 'records', 'translations'],

    data() {
        return {};
    },

    methods: {
        changePage(pageLink) {
            this.$emit('onChangePage', { data: { pageLink } });
        }
    }
};
</script>
